import type { loader } from './AppointmentsDrilldown.data.ts';

import { useLoaderData, useSearchParams } from 'react-router';

import { FiltersPanel } from '#components/FiltersPanel/FiltersPanel.tsx';
import { Address } from '#routes/Home/Filters/Address.tsx';
import { AppointmentTypes } from '#routes/Home/Filters/AppointmentTypes.tsx';
import { BookingChannel } from '#routes/Home/Filters/BookingChannel.tsx';
import { DateRange } from '#routes/Home/Filters/DateRange.tsx';
import { Provider } from '#routes/Home/Filters/Provider.tsx';
import { setProviderFilterSearchParams } from '#routes/Home/Filters/Provider.utils.ts';
import { allProvidersToken } from '#utils/provider-filter.ts';

export function AppointmentsFiltersPanel() {
  const data = useLoaderData<Awaited<ReturnType<typeof loader>>>();
  const [, setSearchParams] = useSearchParams();

  function handleRemoveAll() {
    setSearchParams((sp) => {
      // Only remove filters used in Appointments panel
      sp.delete('view'); // Active view
      sp.delete('dp'); // Date preset
      sp.delete('from'); // Date range start
      sp.delete('to'); // Date range end
      sp.delete('bat'); // Base Appointment Types
      sp.delete('atId'); // Appointment Type IDs
      sp.delete('aId'); // Address IDs
      sp.delete('bcId'); // Booking Channel IDs
      setProviderFilterSearchParams(sp, allProvidersToken);

      // Reset to first page after removing filters
      sp.set('page', '1');
      return sp;
    });
  }

  return (
    <FiltersPanel onRemoveAll={handleRemoveAll}>
      <DateRange
        key={`date-${data.from.getTime()}-${data.to.getTime()}`}
        defaultValue={[data.from, data.to]}
      />
      <Provider
        key={`provider-${JSON.stringify(data.providerIds)}`}
        defaultValue={data.providerIds}
      />
      <AppointmentTypes
        key={`types-${JSON.stringify([data.baseAppointmentTypes, data.appointmentTypeIds])}`}
        defaultValue={{
          baseAppointmentTypes: data.baseAppointmentTypes,
          appointmentTypeIds: data.appointmentTypeIds,
        }}
      />
      <Address key={`address-${JSON.stringify(data.addressIds)}`} defaultValue={data.addressIds} />
      <BookingChannel
        key={`booking-channel-${JSON.stringify(data.bookingChannelIds)}`}
        defaultValue={data.bookingChannelIds}
      />
    </FiltersPanel>
  );
}
